import React from "react";

import "./TextDivider.scss";

export type TextDividerProps = {
  cx?: string;
  text: string;
};

export const TextDivider: React.FC<TextDividerProps> = ({ cx = "", text }) => {
  return (
    <div className={`TextDivider ${cx}`}>
      <hr className={"lhr"} />
      <span>{text}</span>
      <hr className={"rhr"} />
    </div>
  );
};
